import {FlowState} from '@gongxigames/framework/slot/modules/flow/states/FlowState';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {FlowModule} from '@gongxigames/framework/slot/modules/flow/FlowModule';

export class FlowBuyBonusState extends FlowState {
    public onEnterState(): void {
        this.emit(FlowModuleEvents.BLOCKING_FLOW);
        this.emit('General.UI.DISABLE', UIDisableReason.TRIGGERING_FEATURE);
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_INTRO) {
            this.gotoFreeSpins();
        }
    }

    protected gotoFreeSpins(): void {
        this.module.gotoState(FlowModule.FREE_SPINS_STATE);
        this.emit(FlowModuleEvents.CAN_SPIN);
    }
}
